import { useSpinnerStore } from '@/stores/spinner'

export default {
  install(Vue) {
    const spinner = useSpinnerStore()
    let lastShowTs = 0
    const MIN_DISPLAY = 300

    Vue.prototype.$spinner = {
      show() {
        spinner.show()
        lastShowTs = Date.now()
      },
      hide() {
        const elapsed = Date.now() - lastShowTs
        if (elapsed >= MIN_DISPLAY) {
          spinner.hide()
        } else {
          setTimeout(() => spinner.hide(), MIN_DISPLAY - elapsed)
        }
      }
    }
  }
}
